[ViewState]
Mode=
Vid=
FolderType=Generic
